import useMerchantWebPortalAxios from "../../utils/axiosWeb";
import { useDispatch } from "react-redux";
import { settingBillsData, settingBillsObjectData } from "../../features/billsPageSlice";
import useResponse from "../../app/useResponse";

function useTouchApi() {
  const MerchantWebPortalAxios = useMerchantWebPortalAxios();
  const dispatch = useDispatch();
  const { successResponse, errorResponse } = useResponse();
  const errorRes = {
    response: {
      data: {
        isPopup: true,
        PopupTitle: "Error",
        PopupDescription: "Something went wrong. Please try again later.",
      },
    },
  };

  const checkWebKey = async () => {
    const res = await MerchantWebPortalAxios.get(`/api/touch`);

    if (res?.data?.status) {
      sessionStorage.setItem("provider", String(res.data.provider));
      dispatch(settingBillsObjectData({ mainField: "touch", field: "provider", value: res.data.provider }));
    }

    return res.data;
  };

  const KatshCheckBill = async (phoneNumber) => {
    dispatch(settingBillsData({ field: "isloading", value: "pending" }));

    try {
      const payload = {
        phoneNumber,
        pin: sessionStorage.getItem("Token"),
        suyoolUserId: sessionStorage.getItem("SessionID"),
        isCorporate: true,
      };

      const res = await MerchantWebPortalAxios.post(`/touch/checkbill`, payload);

      if (res?.data?.success && res?.data?.status) {
        const raw = res.data.payload || {};
        const details = raw.data || raw;

        dispatch(settingBillsObjectData({ mainField: "touch", field: "provider", value: 0 }));
        dispatch(settingBillsObjectData({ mainField: "touch", field: "MobileNumber", value: phoneNumber }));
        dispatch(settingBillsObjectData({ mainField: "touch", field: "katshOrderDetailsId", value: res.data.katshOrderDetailsId }));
        dispatch(settingBillsObjectData({ mainField: "touch", field: "referenceKey", value: details.ReferenceKey || details.referenceKey }));
        dispatch(settingBillsObjectData({ mainField: "touch", field: "displayData", value: details }));
        dispatch(settingBillsObjectData({ mainField: "touch", field: "displayFee", value: details.Fees || details.fees || 0 }));
        dispatch(settingBillsData({ field: "currentPage", value: "payment-confirmation" }));
        return res;
      }

      const popup = res?.data?.data?.Popup;

      if (popup?.isPopup) {
        successResponse(popup);
      } else {
        errorResponse({
          response: {
            status: 400,
            data: {
              isPopup: true,
              PopupTitle: "Validation Error",
              PopupDescription: res?.data?.message || "Something went wrong.",
            },
          },
        });
      }

      return res;
    } catch (error) {
      errorResponse(error);
      throw error;
    } finally {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
    }
  };

  const TouchBill = async (mobileNumber) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/touch/bill`, {
        mobileNumber: mobileNumber,
      });
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));

      if (res.data.status) {
        if (res?.data?.data?.postpaidRequestId === -1) {
          // toast.warning(res.data.message);
          successResponse(res.data.data.Popup);
        } else {
          dispatch(settingBillsObjectData({ mainField: "touch", field: "provider", value: 1 }));
          dispatch(settingBillsObjectData({ mainField: "touch", field: "MobileNumber", value: mobileNumber }));
          dispatch(settingBillsObjectData({ mainField: "touch", field: "postpaidRequestId", value: res.data.data.postpaidRequestId }));
          dispatch(settingBillsData({ field: "currentPage", value: "pin-confirm" }));
        }
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const RetrieveResults = async (mobileNumber, Pin, invoicesId) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/touch/bill/RetrieveResults`, {
        mobileNumber: mobileNumber,
        currency: "LBP",
        Pin: Pin,
        invoicesId: invoicesId,
      });
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status) {
        if (res.data.data.postpayed !== -1) {
          dispatch(settingBillsObjectData({ mainField: "touch", field: "displayData", value: res.data.data.displayData }));
          dispatch(settingBillsObjectData({ mainField: "touch", field: "displayFee", value: res.data.data.displayedFees }));
          dispatch(settingBillsObjectData({ mainField: "touch", field: "postpayed", value: res.data.data.postpayed }));
          dispatch(settingBillsData({ field: "currentPage", value: "payment-confirmation" }));
        }
         else {
          successResponse(res.data.data.Popup);
        }
      }
      return res.data;
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const PayTouchBill = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/touch/bill/pay`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        return res.data;
      }
      // else {
      //   toast.warning(res.data.message);
      // }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const GetTouchCards = async () => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.get(`/api/touch/ReCharge`);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        return res.data;
      }
      // else {
      //   toast.warning(res.data.message);
      // }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const BuyTouchCard = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/touch/BuyPrePaid`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res.data.data !== -1) {
        dispatch(settingBillsData({ field: "prepaidRes", value: res?.data?.data?.Popup }));
        return res.data;
      }
      // else {
      //   toast.warning(res.data.message);
      // }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  return {
    checkWebKey,
    GetTouchCards,
    BuyTouchCard,
    TouchBill,
    RetrieveResults,
    PayTouchBill,
    KatshCheckBill,
  };
}

export default useTouchApi;
